import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { routing } from './app.routing';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { ErrorComponent } from './pages/error/error.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NotifierModule } from 'angular-notifier';
import { HttpInterceptorService } from './services/http-interceptor.service';
import { LoadingInterceptor } from './services/loading.interceptor';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [
    AppComponent,
    ErrorComponent,
  ],
  exports: [
    NotifierModule,
    BrowserModule,
    BrowserAnimationsModule,
  ],
  imports: [
    SharedModule,
    NotifierModule.withConfig({
      position: {
        horizontal: { position: 'right', distance: 20 },
        vertical: { position: 'bottom', distance: 20, gap: 10 }
      },
      theme: 'material',
      behaviour: {
        autoHide: 4000,
        onClick: 'hide',
        showDismissButton: true,
        stacking: 4
      },
      animations: {
        enabled: true,
        show: { preset: 'slide', speed: 300, easing: 'ease' },
        hide: { preset: 'fade', speed: 300, easing: 'ease' },
        shift: { speed: 300, easing: 'ease' },
        overlap: 150
      }
    }),
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    NgxSpinnerModule,
    CommonModule,
    HttpClientModule,
    BrowserAnimationsModule,
    routing,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    // Loading interceptor runs alongside HttpInterceptorService. Order in the
    // providers array doesn't matter for `multi:true` — Angular runs every
    // registered interceptor for every request. This one drives the spinner.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
